import React, { useEffect, useState } from 'react';
import { Stream } from '../../Models/Stream';
import {
  Typography,
  Grid,
  TextField,
  CircularProgress,
  Box,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import './VideoListingStyles.css'; // Import custom styles
import { useParams } from 'react-router-dom';
import { Category } from '../../Models/Category';
import VideoGrid from './VideoGrid';
import Stack from '@mui/material/Stack';
import { useAPIContext } from '../../Context/APIContext';
import { VideoListingFullPageType } from '../../Models/VideoListingPageType';

const useStyles = makeStyles({
  categoryDescription: {
    width: '100%',
    '@media (min-width: 960px)': {
      width: '80%',
    },
  },
});

interface VideoListingFullProps {
  type: VideoListingFullPageType;
}

export default function VideoListingFull({type}: VideoListingFullProps) {
  const classes = useStyles();
  const { categoryId } = useParams();
  const [filteredStreams, setFilteredStreams] = useState<Stream[]>([]);
  const [streams, setStreams] = useState<Stream[]>([]);
  const [savedStreams, setSavedStreams] = useState<Stream[]>([]);
  const [category, setCategory] = useState<Category>();
  const [loading, setLoading] = useState<boolean>(false);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { apiFetch } = useAPIContext();

  useEffect(() => {
    const fetchStreamData = async () => {
      setLoading(true);

      let streamData;
      let savedStreamData;

      if (type === VideoListingFullPageType.Saved) {
        streamData = await apiFetch<Stream[]>('Users/SavedStreams', 'GET', Stream.fromJsonArray);
        savedStreamData = streamData;
      }else if (type === VideoListingFullPageType.Category) {
        if (!categoryId || !(Number(categoryId) > 0)) {
          setLoading(false);
          return;
        }
        streamData = await apiFetch<Stream[]>(`Streams?categoryId=${categoryId}&limit=${1000}`, 'GET', Stream.fromJsonArray);
        savedStreamData = await apiFetch<Stream[]>('Users/SavedStreams', 'GET', Stream.fromJsonArray);
        const category = await apiFetch<Category>(`Categories/${categoryId}`, 'GET', Category.fromJson);
        if (category) setCategory(category);
      }

      if (streamData) {
        setStreams(streamData);
        setFilteredStreams(streamData);
      }
      if (savedStreamData) {
        setSavedStreams(savedStreamData);
      }

      setLoading(false);
    };

    fetchStreamData();
  }, [categoryId, type, apiFetch]);


  useEffect(() => {
    setSearchLoading(true);
    const lowercasedFilter = searchTerm.toLowerCase();
    const filteredData = streams.filter((stream) =>
      stream.title?.toLowerCase().includes(lowercasedFilter)
    );
    setFilteredStreams(filteredData);
    setSearchLoading(false);
  }, [searchTerm, streams]);

  return (
    <>
      {loading ? (
        <center>
          <CircularProgress style={{ color: '#3D9BE9' }} />
        </center>
      ) : (
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: { xs: 3, sm: 3, md: 3 },
            pb: 5,
            mt: { xs: 1, md: 0 },
          }}
        >
          <Box sx={{ width: '100%', maxWidth: '1700px', pt: 1 }}>

            <Box className="header-section" mb={2}>

              <Grid container spacing={2} alignItems="center" mb={0}>
                <Grid item xs={12} md>
                  {type === VideoListingFullPageType.Category ? (
                    <Typography
                        className="header-text"
                        sx={{
                          fontSize: '1.5em',
                        }}
                      >{category?.name}</Typography>
                  ):null}

                  {type === VideoListingFullPageType.Saved ? (
                     <Typography
                        className="header-text"
                        sx={{
                          fontSize: '1.5em',
                        }}
                      >Saved Videos</Typography>
                  ):null}

                  <Typography
                    variant="body2"
                    color="textSecondary"
                    className={classes.categoryDescription}
                  >
                    {category?.description}
                  </Typography>
                </Grid>
                <Grid item>
                  <TextField
                    label="Search Videos"
                    variant="outlined"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    size="small"
                    sx={{
                      minWidth: { xs: '200px', sm: '250px', md: '300px' },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>



            {searchLoading ? (
              <center>
                <CircularProgress style={{ color: '#3D9BE9' }} />
              </center>
            ) : filteredStreams.length > 0 ? (
              <VideoGrid streams={filteredStreams} savedStreams={savedStreams} categoryId={categoryId ?? ""} />
            ) : (
              <Typography variant="h6" align="center" color="textSecondary" style={{ minHeight: '400px' }}>
                No videos found.
              </Typography>
            )}
          </Box>
        </Stack>
      )}
    </>
  );
}
